import React, { Component } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import { pink } from 'material-ui/colors';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { CookiesProvider } from 'react-cookie';

import Chrome from "./components/chrome.js";
import Setup from "./pages/setup.js"
import Main from "./pages/main.js"
import Language from "./pages/language.js"
import Resources from "./pages/resources.js"

const theme = createMuiTheme({
  palette: {
    primary: {
      ...pink
    }, // Purple and green play nicely together.
  },
});

const client = new ApolloClient({
  link: new HttpLink({ uri: 'https://api.knowmystudents.com/graphql' }),
  cache: new InMemoryCache()
});

class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <CookiesProvider>
          <Router>
            <MuiThemeProvider theme={theme}>
              <Chrome>
                <Switch>
                  <Route exact path="/" component={Setup} />
                  <Route path="/l" component={Language} />
                  <Route path="/m" component={Main} />
                  <Route path="/r/:region?/:lang?" component={Resources} />
                  {/* <Route path="/t" component={} /> */}
                </Switch>
              </Chrome>
            </MuiThemeProvider>
          </Router>
        </CookiesProvider>
      </ApolloProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js